// import React, { useEffect, useState } from "react";
// import {
//   FormControl,
//   MenuItem,
//   Paper,
//   Select,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// // import axios from "axios";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Modal from "@mui/material/Modal";
// import TextField from "@mui/material/TextField";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import AddIcon from "@mui/icons-material/Add";
// import { toast } from "react-toastify";
// import axiosInstance from "../../../config/axios";
// import { getFn, postFn } from "../../../Services/sharedGeneralFn";
// import { API_URLS } from "../../../config/apiUrls";
// import { useQuery } from "react-query";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
//   rounded: 2,
// };

// const MainHeader = () => {
//   const [data, setData] = useState([]);
//   const [countData, setCountData] = useState("");
//   const [open, setOpen] = React.useState(false);
//   const [page, setPage] = React.useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPage, setTotalPage] = useState(null);
//   const [rowData, setRowData] = useState({});
//   // const superuserId = localStorage.getItem("is_superuser");

//   const [searchQuery, setSearchQuery] = useState("");
//   // Add category Name start
//   const [options, setOptions] = useState("category");
//   const [categoryData, setCategoryData] = useState([]);
//   const [subCategoryData, setSubCategoryData] = useState([]);
//   const [brandData, setBrandData] = useState([]);
//   const [categoryId, setCategoryId] = useState("");
//   const [subCategoryId, setSubCategoryId] = useState("");
//   const [brandId, setBrandId] = useState("");

//   const [title, setTitle] = useState("");
//   const [image, setImage] = useState("");
//   const [url, setUrl] = useState("");
//   const [ordering, setOrdering] = useState("");
//   const [ids, setIds] = useState(null);

//   const Store_id = localStorage.getItem("store_id");

//   const headerData = () => {
//     axiosInstance
//       .get(
//         `api/admin/main-customization-header/?search=${searchQuery}&page=${page}&store_id=${Store_id}`,
//         {
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         console.log("header===>", response?.data);
//         setData(response?.data?.data);
//         setCountData(response?.data?.count);
//         setCurrentPage(response.data.current_page);
//         setTotalPage(response.data.total_pages);
//       })
//       .catch((error) => {
//         console.log("", error);
//       });
//   };

//   useEffect(() => {
//     headerData();
//   }, [searchQuery, page]);

//   const submitCategory = () => {
//     const fd = new FormData();
//     fd.append("title", title);
//     fd.append("store_id", Store_id);
//     fd.append("url", url);
//     fd.append("ordering", ordering);
//     fd.append("image", image || rowData?.image);
//     options === "category" &&
//       fd.append(
//         "main_category_id",
//         categoryId || rowData?.main_category?.id || "",
//       );
//     options === "subCategory" &&
//       fd.append(
//         "subcategory_id",
//         subCategoryId | rowData?.subcategory?.id || "",
//       );
//     options === "brand" &&
//       fd.append("brand_id", brandId || rowData?.brand?.id || "");

//     ids === null
//       ? axiosInstance
//           .post(`api/admin/main-customization-header/`, fd, {
//             headers: {
//               Token: localStorage.getItem("Token"),
//               "Content-Type": "multipart/formdata",
//             },
//           })
//           .then((response) => {
//             if (response?.data?.response_code === 200) {
//               toast.success(response.data.message);
//               setTitle("");
//               setIds(null);
//               setUrl("");
//               setOrdering("");
//               setRowData({});
//               handleClose();
//               headerData();
//             } else {
//               toast.error(response.data.message);
//             }
//           })
//           .catch((error) => {
//             console.log("error page", error.response);
//             console.log(error);
//           })
//       : // Edit functionality to business category
//         axiosInstance
//           .put(
//             `api/admin/main-customization-header/?main_customization_header_id=${ids}`,
//             fd,
//             {
//               headers: {
//                 Token: localStorage.getItem("Token"),
//               },
//             },
//           )
//           .then((response) => {
//             if (response?.data?.response_code === 200) {
//               toast.success(response.data.message);
//               setTitle("");
//               setIds(null);
//               setUrl("");
//               setOrdering("");
//               setRowData({});
//               handleClose();
//               headerData();
//             } else {
//               toast.error(response.data.message);
//             }
//           })
//           .catch((error) => {
//             console.log("error page", error.response);
//             console.log(error);
//           });
//   };

//   const previousData = () => {
//     if (page > 1) {
//       setPage(page - 1);
//     }
//   };
//   const nextData = () => {
//     if (page < totalPage) {
//       setPage(page + 1);
//     }
//   };

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const EditFunction = (row) => {
//     console.log(row);
//     setRowData(row);
//     setIds(row?.id);
//     setTitle(row?.title);
//     setUrl(row?.url);
//     setOrdering(row?.ordering);

//     setCategoryId(row?.main_category);
//     setSubCategoryId(row?.subcategory);
//     setBrandId(row?.brand);
//   };

//   const hangleCancel = () => {
//     setTitle("");
//     setIds(null);
//     setUrl("");
//     setOrdering("");
//     setSubCategoryId("");
//     setCategoryId("");
//     setBrandId("");
//     handleClose();
//     headerData();
//   };

//   // const categoryList = () => {
//   //   axiosInstance
//   //     .post(
//   //       `api/multivendor-show-main-category-list-admin/`,
//   //       {},
//   //       {
//   //         headers: {
//   //           Token: localStorage.getItem("Token"),
//   //         },
//   //       },
//   //     )
//   //     .then((response) => {
//   //       setCategoryData(response?.data?.main_category_data);
//   //     })
//   //     .catch((error) => {
//   //       console.log("", error);
//   //     });
//   // };
//   // useEffect(() => {
//   //   categoryList();
//   // }, []);

//   const { data: categories } = useQuery(
//     ["categories"],
//     () => getFn({}, API_URLS.category),
//     {
//       select: (data) =>
//         data?.data?.data.map(({ category, id }) => ({
//           label: category,
//           value: id,
//         })),
//     },
//   );

//   const { data: subcategories } = useQuery(
//     ["subcategories"],
//     () => postFn({}, API_URLS.sub_category),
//     {
//       select: (data) =>
//         data?.data?.sub_cat_list?.map(({ subcategory, id }) => ({
//           label: subcategory,
//           value: id,
//         })),
//     },
//   );

//   const { data: brands } = useQuery(
//     ["brands"],
//     () => postFn({}, "api/admin/multivendor-show-brand-list/"),
//     {
//       select: (data) =>
//         data?.data?.brand_data?.map(({ brand_name, id }) => ({
//           label: brand_name,
//           value: id,
//         })),
//     },
//   );

//   // const subCategoryList = () => {
//   //   axiosInstance
//   //     .post(
//   //       `api/multivendor-show-sub-category-list/`,
//   //       {},
//   //       {
//   //         headers: {
//   //           Token: localStorage.getItem("Token"),
//   //         },
//   //       },
//   //     )
//   //     .then((response) => {
//   //       setSubCategoryData(response?.data?.sub_cat_list);
//   //     })
//   //     .catch((error) => {
//   //       console.log("", error);
//   //     });
//   // };
//   // useEffect(() => {
//   //   subCategoryList();
//   // }, []);

//   // const brandList = () => {
//   //   axiosInstance
//   //     .post(
//   //       `api/multivendor-show-brand-list/`,
//   //       { search_values: "" },
//   //       {
//   //         headers: {
//   //           Token: localStorage.getItem("Token"),
//   //         },
//   //       },
//   //     )
//   //     .then((response) => {
//   //       setBrandData(response?.data?.brand_list_serializer);
//   //     })
//   //     .catch((error) => {
//   //       console.log("", error);
//   //     });
//   // };
//   // useEffect(() => {
//   //   brandList();
//   // }, []);

//   useEffect(() => {
//     console.log("clicked");
//     setOptions(() => {
//       if (rowData?.main_category) {
//         return "category";
//       } else if (rowData?.subcategory) {
//         return "subCategory";
//       } else if (rowData?.brand) {
//         return "brand";
//       } else return "category";
//     });
//   }, [rowData]);

//   const deleteFunction = (e, id) => {
//     e.preventDefault();
//     const trueOk = window.confirm("are you sure delete this header...!");
//     trueOk &&
//       axiosInstance
//         .delete(
//           `api/admin/main-customization-header/?main_customization_header_id=${id}&store_id=${Store_id}`,
//           {
//             headers: {
//               Token: localStorage.getItem("Token"),
//             },
//           },
//         )
//         .then((response) => {
//           toast.success(response.data.message);
//           headerData();
//         })
//         .catch((error) => {
//           console.log("", error);
//         });
//   };

//   return (
//     <div className=" !bg-slate-100">
//       <div className="flex justify-between">
//         <div className="p-2">
//           <p className="text-xl !text-black font font-bold">
//             Manage Customization Main Header List
//           </p>
//           {/* <p className="!text-black">View/Search Product Management List</p> */}
//         </div>
//         <div className="p-2 pt-5">
//           <Button variant="outlined" color="primary" onClick={handleOpen}>
//             <AddIcon />
//             Add Customization Main Header
//           </Button>
//         </div>
//       </div>
//       <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
//         <div className="flex items-center justify-between my-2">
//           <span className="flex  gap-3">
//             <input
//               class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
//               placeholder="Search for anything..."
//               type="text"
//               name="search"
//               value={searchQuery}
//               onChange={(event) => setSearchQuery(event.target.value)}
//             />
//           </span>
//           <span>
//             <div className="text-red-500 mx-3">
//               <Modal
//                 open={open}
//                 onClose={handleClose}
//                 aria-labelledby="child-modal-title"
//                 aria-describedby="child-modal-description"
//               >
//                 <Box
//                   sx={{ ...style, width: 930 }}
//                   className="rounded-2xl !border-0"
//                 >
//                   <div
//                     id="child-modal-title "
//                     className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
//                   >
//                     {ids == null
//                       ? "Add Customization Main Header"
//                       : "Update Customization Main Header"}
//                   </div>
//                   <div className="flex justify-between w-full">
//                     <div className="w-[48%]">
//                       <div>Title :</div>
//                       <TextField
//                         size="small"
//                         value={title}
//                         onChange={(event) => setTitle(event.target.value)}
//                         id="outlined-basic"
//                         className="!w-[100%] !mt-1"
//                       />
//                       <div className="mt-2">Image :</div>
//                       <TextField
//                         onChange={(e) => setImage(e.target.files[0])}
//                         id="outlined-basic"
//                         type="file"
//                         size="small"
//                         className="!w-[100%] !mt-1"
//                       />
//                     </div>
//                     <div className="w-[48%]">
//                       <div className="">URL :</div>
//                       <TextField
//                         value={url}
//                         onChange={(event) => setUrl(event.target.value)}
//                         id="outlined-basic"
//                         size="small"
//                         className="!w-[100%] !mt-1"
//                       />
//                       <div className="mt-2">Ordering :</div>
//                       <TextField
//                         value={ordering}
//                         onChange={(event) => setOrdering(event.target.value)}
//                         id="outlined-basic"
//                         size="small"
//                         className="!w-[100%] !mt-1"
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-2">
//                     <div>Select Header :</div>
//                     <FormControl>
//                       <RadioGroup
//                         row
//                         aria-labelledby="demo-row-radio-buttons-group-label"
//                         name="row-radio-buttons-group"
//                         value={options}
//                         onChange={(e) => setOptions(e.target.value)}
//                       >
//                         <FormControlLabel
//                           value="category"
//                           control={<Radio />}
//                           label="category"
//                         />
//                         <FormControlLabel
//                           value="subCategory"
//                           control={<Radio />}
//                           label="subCategory"
//                         />
//                         <FormControlLabel
//                           value="brand"
//                           control={<Radio />}
//                           label="brand"
//                         />
//                       </RadioGroup>
//                     </FormControl>
//                   </div>
//                   {options === "category" ? (
//                     <div className="mt-2">
//                       <div>Select Category :</div>
//                       <FormControl fullWidth>
//                         <Select
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           size="small"
//                           className="mt-2"
//                           value={categoryId}
//                           onChange={(e) => setCategoryId(e.target.value)}
//                         >
//                           {categories?.map((elem) => (
//                             <MenuItem key={elem?.value} value={elem?.value}>
//                               {elem?.label}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </div>
//                   ) : null}
//                   {/* subcategory */}
//                   {options === "subCategory" ? (
//                     <div className="mt-2">
//                       <div>Select Sub Category :</div>
//                       <FormControl fullWidth>
//                         <Select
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           size="small"
//                           className="mt-2"
//                           value={subCategoryId}
//                           onChange={(e) => setSubCategoryId(e.target.value)}
//                         >
//                           {subcategories.map((elem) => (
//                             <MenuItem value={elem?.value}>
//                               {elem?.label}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </div>
//                   ) : null}
//                   {options === "brand" ? (
//                     <div className="mt-2">
//                       <div>Select Brand :</div>
//                       <FormControl fullWidth>
//                         <Select
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           size="small"
//                           className="mt-2"
//                           value={brandId}
//                           onChange={(e) => setBrandId(e.target.value)}
//                         >
//                           {brands?.map((elem) => (
//                             <MenuItem value={elem?.value}>
//                               {elem?.label}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </div>
//                   ) : null}

//                   <Button
//                     onClick={hangleCancel}
//                     variant="contained"
//                     color="warning"
//                     className="!py-2 !mt-3"
//                   >
//                     CANCEL
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="success"
//                     className="!py-2 !px-5 !font-bold !mt-3 !float-right"
//                     onClick={submitCategory}
//                   >
//                     {ids === null ? "ADD" : "UPDATE"}
//                   </Button>
//                 </Box>
//               </Modal>
//             </div>
//           </span>
//         </div>
//         <TableContainer
//           component={Paper}
//           // sx={{  }}
//           sx={{ width: "100%", maxHeight: 440 }}
//           className="!text-black !mx-auto !bg-white overflow-auto px-2"
//         >
//           <Table stickyHeader aria-label="sticky table" size="small">
//             <TableHead>
//               <TableRow>
//                 {/* <TableCell className="!text-left !p-2">
//                   <Checkbox className="!m-0 !text-black" />
//                 </TableCell> */}
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ID
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   TITLE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   CATEGORY
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   SUB CATEGORY
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   BRAND
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   URL
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   IMAGE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ORDERING
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ACTION
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody className="!bg-red">
//               {data &&
//                 data?.map((row, index) => (
//                   <TableRow key={row?.id} className="!text-slate-700">
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {index + 1}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {" "}
//                       {row?.title ? row?.title : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {" "}
//                       {row?.category_name ? row?.category_name : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {" "}
//                       {row?.subcategory_name ? row?.subcategory_name : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {" "}
//                       {row?.brand_name ? row?.brand_name : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.url ? row?.url : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.image ? (
//                         <img src={row?.image} className="h-8 mx-auto w-8" />
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.ordering ? row?.ordering : "--"}
//                     </TableCell>

//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       <DeleteIcon
//                         className="!text-xl !text-red-600 !cursor-pointer"
//                         onClick={(e) => deleteFunction(e, row?.id)}
//                       />
//                       <button onClick={handleOpen}>
//                         <EditIcon
//                           className="!text-xl !cursor-pointer !text-green-600"
//                           onClick={() => EditFunction(row)}
//                         />
//                       </button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         {/* <div
//           className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
//           style={{ marginRight: "0px" }}
//         >
//           <button onClick={nextData} className="!float-right">
//             {currentPage}... {totalPage}
//             <ArrowForwardIosIcon />
//           </button>
//           <button onClick={previousData} className="float-right">
//             <ArrowBackIosIcon />
//           </button>
//         </div> */}
//         <div
//           className="flex justify-between bg-white w-[100%] py-3 border-t-2 border-gray-400"
//           style={{ marginRight: "0px" }}
//         >
//           <div className="mx-3">
//             Count : <span className="text-fuchsia-600">{countData}</span>
//           </div>
//           <div>
//             <Button className="" disabled={page === 1}>
//               <ArrowBackIosIcon onClick={previousData} />
//             </Button>
//             {currentPage}...{totalPage}
//             <Button className="" disabled={totalPage === page}>
//               <ArrowForwardIosIcon onClick={nextData} />
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MainHeader;

import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import axiosInstance from "../../../config/axios";
import { getFn, postFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import { useQuery } from "react-query";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const cellSx = {
  borderRight: "1px solid #D0D0D0",
  fontFamily: "'Poppins', sans-serif",
  fontSize: "11px",
  padding: "3px 8px",
  textAlign: "center",
  lineHeight: 1.2,
};

const headSx = {
  ...cellSx,
  fontWeight: 700,
  color: "#1f2937",
  whiteSpace: "nowrap",
};

const MainHeader = () => {
  const [data, setData] = useState([]);
  const [countData, setCountData] = useState("");
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [rowData, setRowData] = useState({});
  // const superuserId = localStorage.getItem("is_superuser");

  const [searchQuery, setSearchQuery] = useState("");
  // Add category Name start
  const [options, setOptions] = useState("category");
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [brandId, setBrandId] = useState("");

  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const [ordering, setOrdering] = useState("");
  const [ids, setIds] = useState(null);

  const Store_id = localStorage.getItem("store_id");

  const headerData = () => {
    axiosInstance
      .get(
        `api/admin/main-customization-header/?search=${searchQuery}&page=${page}&store_id=${Store_id}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log("header===>", response?.data);
        setData(response?.data?.data);
        setCountData(response?.data?.count);
        setCurrentPage(response.data.current_page);
        setTotalPage(response.data.total_pages);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    headerData();
  }, [searchQuery, page]);

  const submitCategory = () => {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("store_id", Store_id);
    fd.append("url", url);
    fd.append("ordering", ordering);
    fd.append("image", image || rowData?.image);
    options === "category" &&
      fd.append(
        "main_category_id",
        categoryId || rowData?.main_category?.id || "",
      );
    options === "subCategory" &&
      fd.append(
        "subcategory_id",
        subCategoryId | rowData?.subcategory?.id || "",
      );
    options === "brand" &&
      fd.append("brand_id", brandId || rowData?.brand?.id || "");

    ids === null
      ? axiosInstance
          .post(`api/admin/main-customization-header/`, fd, {
            headers: {
              Token: localStorage.getItem("Token"),
              "Content-Type": "multipart/formdata",
            },
          })
          .then((response) => {
            if (response?.data?.response_code === 200) {
              toast.success(response.data.message);
              setTitle("");
              setIds(null);
              setUrl("");
              setOrdering("");
              setRowData({});
              handleClose();
              headerData();
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          })
      : // Edit functionality to business category
        axiosInstance
          .put(
            `api/admin/main-customization-header/?main_customization_header_id=${ids}`,
            fd,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            if (response?.data?.response_code === 200) {
              toast.success(response.data.message);
              setTitle("");
              setIds(null);
              setUrl("");
              setOrdering("");
              setRowData({});
              handleClose();
              headerData();
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          });
  };

  const previousData = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const nextData = () => {
    if (page < totalPage) {
      setPage(page + 1);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const EditFunction = (row) => {
    console.log(row);
    setRowData(row);
    setIds(row?.id);
    setTitle(row?.title);
    setUrl(row?.url);
    setOrdering(row?.ordering);

    setCategoryId(row?.main_category);
    setSubCategoryId(row?.subcategory);
    setBrandId(row?.brand);
  };

  const hangleCancel = () => {
    setTitle("");
    setIds(null);
    setUrl("");
    setOrdering("");
    setSubCategoryId("");
    setCategoryId("");
    setBrandId("");
    handleClose();
    headerData();
  };

  const { data: categories } = useQuery(
    ["categories"],
    () => getFn({}, API_URLS.category),
    {
      select: (data) =>
        data?.data?.data.map(({ category, id }) => ({
          label: category,
          value: id,
        })),
    },
  );

  const { data: subcategories } = useQuery(
    ["subcategories"],
    () => postFn({}, API_URLS.sub_category),
    {
      select: (data) =>
        data?.data?.sub_cat_list?.map(({ subcategory, id }) => ({
          label: subcategory,
          value: id,
        })),
    },
  );

  const { data: brands } = useQuery(
    ["brands"],
    () => postFn({}, "api/admin/multivendor-show-brand-list/"),
    {
      select: (data) =>
        data?.data?.brand_data?.map(({ brand_name, id }) => ({
          label: brand_name,
          value: id,
        })),
    },
  );

  useEffect(() => {
    console.log("clicked");
    setOptions(() => {
      if (rowData?.main_category) {
        return "category";
      } else if (rowData?.subcategory) {
        return "subCategory";
      } else if (rowData?.brand) {
        return "brand";
      } else return "category";
    });
  }, [rowData]);

  const deleteFunction = (e, id) => {
    e.preventDefault();
    const trueOk = window.confirm("are you sure delete this header...!");
    trueOk &&
      axiosInstance
        .delete(
          `api/admin/main-customization-header/?main_customization_header_id=${id}&store_id=${Store_id}`,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          },
        )
        .then((response) => {
          toast.success(response.data.message);
          headerData();
        })
        .catch((error) => {
          console.log("", error);
        });
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Customization Main Header List
          </p>
          {/* <p className="!text-black">View/Search Product Management List</p> */}
        </div>
        <div className="p-2 pt-5">
          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{
              fontSize: 11,
              py: 0.25,
              minHeight: 28,
              textTransform: "none",
            }}
            onClick={handleOpen}
          >
            <AddIcon sx={{ fontSize: 16 }} />
            Add Customization Main Header
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-1">
          <span className="flex gap-3">
            <input
              class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-64 border border-slate-300 rounded-md px-2 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 text-xs"
              style={{ height: 28 }}
              placeholder="Search for anything..."
              type="text"
              name="search"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 930 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids == null
                      ? "Add Customization Main Header"
                      : "Update Customization Main Header"}
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div>Title :</div>
                      <TextField
                        size="small"
                        value={title}
                        onChange={(event) => setTitle(event.target.value)}
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Image :</div>
                      <TextField
                        onChange={(e) => setImage(e.target.files[0])}
                        id="outlined-basic"
                        type="file"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                    <div className="w-[48%]">
                      <div className="">URL :</div>
                      <TextField
                        value={url}
                        onChange={(event) => setUrl(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Ordering :</div>
                      <TextField
                        value={ordering}
                        onChange={(event) => setOrdering(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div>Select Header :</div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={options}
                        onChange={(e) => setOptions(e.target.value)}
                      >
                        <FormControlLabel
                          value="category"
                          control={<Radio />}
                          label="category"
                        />
                        <FormControlLabel
                          value="subCategory"
                          control={<Radio />}
                          label="subCategory"
                        />
                        <FormControlLabel
                          value="brand"
                          control={<Radio />}
                          label="brand"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {options === "category" ? (
                    <div className="mt-2">
                      <div>Select Category :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={categoryId}
                          onChange={(e) => setCategoryId(e.target.value)}
                        >
                          {categories?.map((elem) => (
                            <MenuItem key={elem?.value} value={elem?.value}>
                              {elem?.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                  {/* subcategory */}
                  {options === "subCategory" ? (
                    <div className="mt-2">
                      <div>Select Sub Category :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={subCategoryId}
                          onChange={(e) => setSubCategoryId(e.target.value)}
                        >
                          {subcategories.map((elem) => (
                            <MenuItem value={elem?.value}>
                              {elem?.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                  {options === "brand" ? (
                    <div className="mt-2">
                      <div>Select Brand :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={brandId}
                          onChange={(e) => setBrandId(e.target.value)}
                        >
                          {brands?.map((elem) => (
                            <MenuItem value={elem?.value}>
                              {elem?.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}

                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids === null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "70vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={headSx}>ID</TableCell>
                <TableCell sx={headSx}>TITLE</TableCell>
                <TableCell sx={headSx}>CATEGORY</TableCell>
                <TableCell sx={headSx}>SUB CATEGORY</TableCell>
                <TableCell sx={headSx}>BRAND</TableCell>
                <TableCell sx={headSx}>URL</TableCell>
                <TableCell sx={headSx}>IMAGE</TableCell>
                <TableCell sx={headSx}>ORDERING</TableCell>
                <TableCell sx={{ ...headSx, borderRight: "none" }}>
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row?.id} hover className="!text-slate-700">
                    <TableCell sx={cellSx}>{index + 1}</TableCell>
                    <TableCell sx={cellSx}>
                      {row?.title ? row?.title : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.category_name ? row?.category_name : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.subcategory_name ? row?.subcategory_name : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.brand_name ? row?.brand_name : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.url ? row?.url : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt=""
                          className="h-6 w-6 mx-auto object-cover"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.ordering ? row?.ordering : "--"}
                    </TableCell>

                    <TableCell
                      sx={{
                        ...cellSx,
                        borderRight: "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <DeleteIcon
                        sx={{ fontSize: 16 }}
                        className="!text-red-600 !cursor-pointer"
                        onClick={(e) => deleteFunction(e, row?.id)}
                      />
                      <button
                        onClick={handleOpen}
                        style={{ padding: 0, marginLeft: 4 }}
                      >
                        <EditIcon
                          sx={{ fontSize: 16 }}
                          className="!cursor-pointer !text-green-600"
                          onClick={() => EditFunction(row)}
                        />
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div
          className="flex justify-between items-center bg-white w-[100%] py-1 border-t-2 border-gray-400 text-xs"
          style={{ marginRight: "0px" }}
        >
          <div className="mx-3">
            Count : <span className="text-fuchsia-600">{countData}</span>
          </div>
          <div className="flex items-center">
            <Button
              className=""
              size="small"
              sx={{ minWidth: 0, p: 0.5 }}
              disabled={page === 1}
            >
              <ArrowBackIosIcon sx={{ fontSize: 14 }} onClick={previousData} />
            </Button>
            {currentPage}...{totalPage}
            <Button
              className=""
              size="small"
              sx={{ minWidth: 0, p: 0.5 }}
              disabled={totalPage === page}
            >
              <ArrowForwardIosIcon sx={{ fontSize: 14 }} onClick={nextData} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainHeader;
